<template>
  <v-menu offset-y offset-x left>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on"
        ><v-icon color="blue-grey">mdi-emoticon-happy-outline </v-icon></v-btn
      >
    </template>

    <div
      class="white emojicontainer d-flex flex-wrap justify-space-around pa-3"
    >
      <div
        class="ma-0 pa-0 px-3 py-2 font-size-24 cursor-pointer rounded emoji"
        v-for="(emoji, index) in $constants.defaultEmojiTable"
        :key="index"
        @click="$emit('insertEmoji', emoji)"
      >
        {{ emoji }}
      </div>
    </div>
  </v-menu>
</template>
<script>
export default {
  name: 'EmojiPicker',
}
</script>
<style lang="scss">
.emojicontainer {
  width: 370px;
  .emoji:hover {
    background-color: $color-blue-grey-lighten3;
  }
}
</style>
